import React, { useState, useEffect } from 'react';
import { Modal, Form, Input, message } from 'antd';
import api from '../utils/api';

const EditHostelModal = ({ hostel, onClose, onSuccess }) => {
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();

  useEffect(() => {
    if (hostel) {
      form.setFieldsValue({
        name: hostel.name || '',
        street: hostel.address?.street || '',
        city: hostel.address?.city || '',
        country: hostel.address?.country || '',
        postalCode: hostel.address?.postalCode || '',
        description: hostel.description || '',
      });
    }
  }, [hostel, form]);

  const handleSubmit = async () => {
    try {
      const values = await form.validateFields();
      setLoading(true);
      const payload = {
        name: values.name,
        address: {
          street: values.street || '',
          city: values.city,
          country: values.country,
          postalCode: values.postalCode || '',
        },
        description: values.description || '',
      };
      await api.put(`/hostels/${hostel._id}`, payload);
      message.success('Hostel updated');
      onSuccess();
      onClose();
    } catch (err) {
      if (err.errorFields) return;
      message.error(err.response?.data?.message || 'Update failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      title="Edit Hostel"
      open={!!hostel}
      onCancel={onClose}
      onOk={handleSubmit}
      confirmLoading={loading}
      destroyOnClose
      okText="Save"
    >
      <Form form={form} layout="vertical">
        <Form.Item name="name" label="Hostel Name" rules={[{ required: true }]}>
          <Input placeholder="Name" />
        </Form.Item>
        <Form.Item name="street" label="Street">
          <Input placeholder="Street" />
        </Form.Item>
        <Form.Item name="city" label="City" rules={[{ required: true }]}>
          <Input placeholder="City" />
        </Form.Item>
        <Form.Item name="country" label="Country" rules={[{ required: true }]}>
          <Input placeholder="Country" />
        </Form.Item>
        <Form.Item name="postalCode" label="Postal Code">
          <Input placeholder="Postal Code" />
        </Form.Item>
        <Form.Item name="description" label="Description">
          <Input.TextArea rows={3} placeholder="Description" />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default EditHostelModal;
